// src/stores/useTheme.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTheme = defineStore('theme', () => {
  const currentTheme = ref<'light' | 'dark'>('dark')  // OPTIMIZATION: Default to dark

  const _applyTheme = (theme: 'light' | 'dark') => {
    currentTheme.value = theme
    const html = document.documentElement
    html.classList.remove('light', 'dark')
    html.classList.add(theme)
  }

  const initTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    // OPTIMIZATION: Always default to dark unless explicitly set to light
    _applyTheme(savedTheme === 'light' ? 'light' : 'dark')
  }

  const toggleTheme = () => {
    const newTheme = currentTheme.value === 'dark' ? 'light' : 'dark'
    _applyTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  return {
    currentTheme,
    initTheme,
    toggleTheme,
  }
})